var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10 4.94141H21C21.6 4.94141 22 5.31788 22 5.88258V7.76494H10V4.94141Z",
    fill: "#4776E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 4H3C2.4 4 2 4.37647 2 4.94118V19.0588C2 19.6235 2.4 20 3 20H21C21.6 20 22 19.6235 22 19.0588V7.76471C22 7.2 21.6 6.82353 21 6.82353H12L10.4 4.56472C10.2 4.18824 9.7 4 9.2 4Z",
    fill: "#4776E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueFolderIcon);
export default __webpack_public_path__ + "static/media/blue-folder-icon.64851d9633d827da9937d15a33746a97.svg";
export { ForwardRef as ReactComponent };